// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__us4x9","errors":"Errors_errors__1nd17"};